import cn from 'classnames';
import { IconProps } from 'components/Shared/Icon';
import { iconStyles } from 'components/Shared/Icon/iconStyles';

// tslint:disable: max-line-length
export const IconPhone = (props: IconProps) => (
  <svg className={cn(iconStyles(props))} viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
    <path
      stroke="none"
      fillRule={props.fill ? 'inherit' : 'evenodd'}
      clipRule="evenodd"
      d="M1 0H4.5C5.05 0 5.5 0.45 5.5 1C5.5 2.25 5.7 3.45 6.07 4.57C6.18 4.92 6.1 5.31 5.82 5.59L3.62 7.79C5.06 10.62 7.38 12.93 10.21 14.38L12.41 12.18C12.61 11.99 12.86 11.89 13.12 11.89C13.22 11.89 13.33 11.9 13.43 11.94C14.55 12.31 15.76 12.51 17 12.51C17.55 12.51 18 12.96 18 13.51V17C18 17.55 17.55 18 17 18C7.61 18 0 10.39 0 1C0 0.45 0.45 0 1 0ZM3.54 2C3.6 2.89 3.75 3.76 3.99 4.59L2.79 5.79C2.38 4.59 2.12 3.32 2.03 2H3.54ZM13.4 14.02C14.25 14.26 15.12 14.41 16 14.47V15.96C14.68 15.87 13.41 15.61 12.2 15.21L13.4 14.02Z"
    />
  </svg>
);
